import { useState, useEffect } from 'react';
import { fetchCmsCollection, getResizedImageUrl } from '../lib/cms';
import GalleryLightbox from '../components/GalleryLightbox';

export default function ProjectsPage() {
  const [activeCategory, setActiveCategory] = useState('alle');
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [cmsItems, setCmsItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fallbackProjects = [
    {
      title: 'Sort-hvid kofigur i garage (Før)',
      category_slug: 'indendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240111-123722-scaled.jpg'],
      alt_text: 'Sort-hvid kofigur i garage'
    },
    {
      title: 'Sort-hvid kostatue i værksted (Efter)',
      category_slug: 'indendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240112-161618-scaled.jpg'],
      alt_text: 'Sort-hvid kostatue i værksted på palle'
    },
    {
      title: 'Hems med sort gelænder',
      category_slug: 'indendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240109-130816-scaled.jpg'],
      alt_text: 'Hems med sort gelænder og plastdækket gulv'
    },
    {
      title: 'Indendørs trapperenovering',
      category_slug: 'indendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240108-140106-scaled.jpg'],
      alt_text: 'Trappe med gelænder og afdækket gulv'
    },
    {
      title: 'Indendørs trappe med grønt gelænder',
      category_slug: 'indendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240718-081024-scaled.jpg'],
      alt_text: 'Indendørs trappe med grøn gelænder og hvide vægge'
    },
    {
      title: 'Hvide dobbeltdøre med glasruder',
      category_slug: 'indendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt007.jpg'],
      alt_text: 'Hvide dobbeltdøre med glasruder indendørs'
    },
    {
      title: 'Klassisk hvid dør med paneler',
      category_slug: 'indendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt006.jpg'],
      alt_text: 'Hvid klassisk indendørs dør med paneler'
    },
    {
      title: 'Køkken med geometrisk tapet',
      category_slug: 'indendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240327-161629-scaled.jpg'],
      alt_text: 'Moderne køkken med geometrisk tapet'
    },
    {
      title: 'Træhoveddør (Før)',
      category_slug: 'udendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt003.jpg'],
      alt_text: 'Brun træhoveddør med paneler'
    },
    {
      title: 'Træhoveddør (Efter)',
      category_slug: 'udendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt004.jpg'],
      alt_text: 'Brun hoveddør med hvid karm'
    },
    {
      title: 'Sort træhus med rødt tegltag',
      category_slug: 'udendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20250812-144318-scaled.jpg'],
      alt_text: 'Sort træhus med rødt tegltag og have'
    },
    {
      title: 'Mørkeblå trægarage',
      category_slug: 'udendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240807-125724-scaled.jpg'],
      alt_text: 'Mørkeblå trægarage med nymalet facade'
    },
    {
      title: 'Moderne villa med nymalet facade',
      category_slug: 'udendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240521-125720-scaled.jpg'],
      alt_text: 'Moderne hvidt hus med stor grøn have'
    },
    {
      title: 'Nymalet murstensfacade med sorte detaljer',
      category_slug: 'udendors-projekter',
      image_url: ['https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240527-112222-scaled.jpg'],
      alt_text: 'Nymalet hvid murstensfacade'
    }
  ];

  useEffect(() => {
    async function loadData() {
      const items = await fetchCmsCollection('galleries');
      if (items && items.length > 0) {
        setCmsItems(items);
      } else {
        setCmsItems(fallbackProjects);
      }
      setLoading(false);
    }
    loadData();
  }, []);

  const projectsToDisplay = cmsItems.length > 0 ? cmsItems : fallbackProjects;

  const filteredProjects = activeCategory === 'alle'
    ? projectsToDisplay
    : projectsToDisplay.filter(p => p.category_slug === activeCategory);

  return (
    <div className="bg-[#F8FAFC] pt-28 pb-20">
      
      {/* Banner */}
      <section className="bg-[#1D352E] text-white py-16 mb-12 -mt-[10px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-white text-sm font-semibold tracking-wider uppercase">
              Galleri & Referencer
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight">
              Se mine tidligere projekter
            </h1>
            <p className="text-gray-200 text-lg">
              Her kan du få inspiration og se udvalgte eksempler på vores malerarbejde udført for tilfredse kunder i Nord- og Midtjylland.
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
        
        {/* Category Filter Tabs */}
        <div className="flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => setActiveCategory('alle')}
            className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer ${
              activeCategory === 'alle'
                ? 'bg-[#1D352E] text-white shadow-md'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-slate-200'
            }`}
          >
            Alle projekter
          </button>

          <button
            type="button"
            onClick={() => setActiveCategory('indendors-projekter')}
            className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer ${
              activeCategory === 'indendors-projekter'
                ? 'bg-[#1D352E] text-white shadow-md'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-slate-200'
            }`}
          >
            Indendørs Projekter
          </button>

          <button
            type="button"
            onClick={() => setActiveCategory('udendors-projekter')}
            className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer ${
              activeCategory === 'udendors-projekter'
                ? 'bg-[#1D352E] text-white shadow-md'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-slate-200'
            }`}
          >
            Udendørsprojekter
          </button>
        </div>

        {/* Gallery Grid */}
        {loading ? (
          <div className="py-20 text-center text-gray-500">
            <i className="fa-solid fa-spinner fa-spin text-2xl mb-2 text-[#65237e]" />
            <p>Henter projekter...</p>
          </div>
        ) : filteredProjects.length === 0 ? (
          <div className="py-16 text-center text-gray-500 bg-white rounded-2xl border border-gray-200">
            Ingen projekter fundet i denne kategori.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredProjects.map((item, idx) => {
              const imgUrl = Array.isArray(item.image_url) ? item.image_url[0] : item.image_url;
              return (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer flex flex-col"
                >
                  <div className="aspect-4/3 overflow-hidden bg-gray-100 relative">
                    <img
                      src={getResizedImageUrl(imgUrl, 600, 80)}
                      alt={item.alt_text || item.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                      <span className="px-3 py-1.5 bg-[#1D352E] text-white text-xs font-semibold rounded-lg shadow">
                        <i className="fa-solid fa-magnifying-glass-plus mr-1.5" />
                        Åbn billede
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      </div>

      <GalleryLightbox
        images={filteredProjects.map(p => ({
          src: Array.isArray(p.image_url) ? p.image_url[0] : p.image_url,
          title: p.title,
          alt: p.alt_text || p.title
        }))}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : filteredProjects.length - 1))}
        onNext={() => setLightboxIndex((prev) => (prev < filteredProjects.length - 1 ? prev + 1 : 0))}
      />
    </div>
  );
}
